// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.trustmanagement

import org.multipaz.cbor.DataItem
import org.multipaz.trustmanagement.TrustEntryX509Cert
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.trustmanagement.TrustMetadata
import org.multipaz.crypto.X509Cert
import org.multipaz.trustmanagement.toDataItem
import org.multipaz.trustmanagement.fromDataItem

fun TrustEntryX509Cert.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Lkly58FPSi-edU5_EglsKebYY4RhCmDP5VlxmHsK_h8")
val TrustEntryX509Cert_cborSchemaId = ByteString(46, 73, 114, -25, -63, 79, 74, 47, -98, 117, 78, 127, 18, 9, 108, 41, -26, -40, 99, -124, 97, 10, 96, -49, -27, 89, 113, -104, 123, 10, -2, 31)

fun TrustEntryX509Cert.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "X509Cert")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("metadata", this.metadata.toDataItem())
    builder.put("certificate", this.certificate.toDataItem())
    return builder.end().build()
}

fun TrustEntryX509Cert_fromDataItem(dataItem: DataItem): TrustEntryX509Cert {
    val identifier = dataItem["identifier"].asTstr
    val metadata = TrustMetadata.fromDataItem(dataItem["metadata"])
    val certificate = X509Cert.fromDataItem(dataItem["certificate"])
    return TrustEntryX509Cert(
        identifier = identifier,
        metadata = metadata,
        certificate = certificate,
    )
}
